import { useDispatch } from 'react-redux'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { RootState } from '@dashboard/store'

export function useAppDispatch() {
  return useDispatch<ThunkDispatch<RootState, unknown, Action>>()
}
